<h2>{{ header$ | async }}</h2>
